@if (isLoading$ | async) {
  <div class="overlay">
    <div class="loader"></div>
  </div>
}
